import { isoDate } from './dateHelpers'

export function mungeShopOrderParams(params) {
  let start_date = params.start_date
  let end_date = params.end_date
  if (start_date) start_date = isoDate(start_date)
  if (end_date) end_date = isoDate(end_date)

  return { ...params, start_date, end_date }
}
